module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout--page__shipping__info--value"
  }, [(_vm.type === 'TEXT') ? [_c('input', {
    attrs: {
      "type": "text",
      "name": _vm.field_name,
      "placeholder": _vm.title
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "change": _vm.update_value
    }
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'DATE') ? [_c('input', {
    class: {
      'empty': !_vm.localValue
    },
    attrs: {
      "type": "date",
      "name": _vm.field_name,
      "placeholder": _vm.title
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "change": _vm.update_value
    }
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'TEXTAREA') ? [_c('textarea', {
    attrs: {
      "cols": "30",
      "rows": "6",
      "name": _vm.field_name,
      "placeholder": _vm.title
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "change": _vm.update_value
    }
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'DROPDOWN') ? [_c('select', {
    class: {
      'empty': !_vm.localValue
    },
    attrs: {
      "name": _vm.field_name
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "change": _vm.update_value
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "default": "",
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.data), function(item) {
    return (item.value && item.name) ? _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  })], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45d2b55a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/form-item.vue
// module id = 254
// module chunks = 1